import * as _ from "lodash";
import { TableWidget } from "./TableWidget";
import { i18nFilter } from "app/filters/i18nFilter";
import { WWOTopRefCategoriesTemplateV2 } from "app/components/widget/dashboard/WWOTopRefCategoriesTemplate-v2";

export interface categoryItem {
    Category: string;
    Share: number;
}
// this widget is being used in dashboard
export class WWOTopRefCategoriesWidget extends TableWidget {
    public CATEGORY_DIVIDER = "/";

    /**
     * See JIRA SIM-32273 for more details: we want to remove "add to dashboard" button
     * from this widget when it appears on the website performance (traffic-overview) page,
     * on every package, besides the websiteResearch package (legacy)
     */
    public hideAddToDashboard: boolean;

    static getWidgetMetadataType() {
        return "WWOTopRefCategories";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getWidgetDashboardType() {
        return "Table";
    }

    constructor() {
        super();
    }

    initWidget(widgetConfig, context) {
        this.viewOptions.link = this._swNavigator.href(
            "digitalsuite_website_referrals_incomingtraffic",
            this._swNavigator.getParams(),
        );
        this.viewOptions.target = "_self";
        this.viewOptions.ctaButtonTracking = `Marketing Mix/Top Referring Categories/${i18nFilter()(
            "wwo.referring.categories.button",
        )}`;
        super.initWidget(widgetConfig, context);
        this.hideAddToDashboard = widgetConfig?.properties?.hideAddToDashboard ?? false;
    }

    callbackOnGetData(response: any) {
        // Server return always 6 results or less, remove "Unknown" if there's another category to show instead
        if (response.Data.length === 6) {
            response.Data = _.remove(response.Data, (item) => item["Category"] !== "Unknown");
            response.Records = _.remove(response.Records, (item) => item["Category"] !== "Unknown");
            if (response.Data.length === 6) {
                response.Data = response.Data.slice(0, 5);
                response.Records = response.Records.slice(0, 5);
            }
        }

        response.Data = _.map(response.Data, (item: categoryItem) => {
            return {
                Category: item.Category.replace("/", "~"),
                Share: item.Share,
            };
        });

        super.callbackOnGetData(response);
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/wwotable.html`;
    }
    get templateComponent() {
        return WWOTopRefCategoriesTemplateV2;
    }
}

WWOTopRefCategoriesWidget.register();
